import React from 'react';
import { Route } from 'react-router-dom';

// pages
import LoginForm from '../components/forms/login-form';
import SignupForm from '../components/forms/signup-form/signup-form';
import Loader from '../components/loader';
import { BASE_AUTH_PATH, BASE_SIGNUP_PATH } from '../constants';
import Authorization from '../modules/authorization';

const UnAuthorizedPaths = () => (
  <Authorization>
    <Route
      path={[BASE_AUTH_PATH, `${BASE_AUTH_PATH}/login`]}
      exact
      component={LoginForm}
    />
    <Route path={BASE_SIGNUP_PATH} component={SignupForm} />
    <Loader singup />
  </Authorization>
);

export default UnAuthorizedPaths;
